const RSS_FEEDS = [
  {
    name: 'Dev.to',
    url: 'https://dev.to/feed',
    icon: '📝',
    color: 'bg-black',
  },
  {
    name: 'GitHub Blog',
    url: 'https://github.blog/feed/',
    icon: '🐙',
    color: 'bg-gray-800',
  },
  {
    name: 'Hacker News',
    url: 'https://hnrss.org/frontpage',
    icon: '📰',
    color: 'bg-orange-500',
  },
  {
    name: 'CSS Tricks',
    url: 'https://css-tricks.com/feed/',
    icon: '🎨',
    color: 'bg-orange-400',
  },
  {
    name: 'Smashing Magazine',
    url: 'https://www.smashingmagazine.com/feed/',
    icon: '📕',
    color: 'bg-red-500',
  },
  {
    name: 'JavaScript Weekly',
    url: 'https://javascriptweekly.com/rss/',
    icon: '🟨',
    color: 'bg-yellow-500',
  },
  {
    name: 'React Blog',
    url: 'https://react.dev/rss.xml',
    icon: '⚛️',
    color: 'bg-cyan-500',
  },
  {
    name: 'Frontend Focus',
    url: 'https://frontendfoc.us/rss/',
    icon: '🎯',
    color: 'bg-blue-500',
  },
];

const CORS_PROXIES = ['https://corsproxy.io/?', 'https://api.codetabs.com/v1/proxy?quest='];

async function fetchWithProxy(url, proxyIndex = 0) {
  if (proxyIndex >= CORS_PROXIES.length) {
    throw new Error('All proxies failed');
  }

  try {
    const proxy = CORS_PROXIES[proxyIndex];
    const response = await fetch(`${proxy}${encodeURIComponent(url)}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response;
  } catch (error) {
    // Try next proxy
    return fetchWithProxy(url, proxyIndex + 1);
  }
}

async function fetchRSSFeed(feedConfig) {
  try {
    const response = await fetchWithProxy(feedConfig.url);
    const text = await response.text();
    const parser = new DOMParser();
    const xml = parser.parseFromString(text, 'text/xml');

    const items = [];
    const entries = xml.querySelectorAll('item, entry');

    entries.forEach((entry) => {
      const title = entry.querySelector('title')?.textContent || '';
      const link =
        entry.querySelector('link')?.textContent ||
        entry.querySelector('link')?.getAttribute('href') ||
        '';
      const description = entry.querySelector('description, summary, content')?.textContent || '';
      const pubDate = entry.querySelector('pubDate, published, updated')?.textContent || '';
      const author = entry.querySelector('author name, dc\\:creator, creator')?.textContent || '';

      // Try to extract image from content or media
      let image = '';
      const mediaContent = entry.querySelector('media\\:content, media\\:thumbnail');
      if (mediaContent) {
        image = mediaContent.getAttribute('url') || '';
      }
      if (!image) {
        const enclosure = entry.querySelector('enclosure[type^="image"]');
        if (enclosure) {
          image = enclosure.getAttribute('url') || '';
        }
      }
      if (!image) {
        // Try to extract from description HTML
        const imgMatch = description.match(/<img[^>]+src="([^">]+)"/);
        if (imgMatch) {
          [, image] = imgMatch;
        }
      }

      // Clean description from HTML tags
      const cleanDescription = description
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .trim()
        .slice(0, 200);

      items.push({
        id: `${feedConfig.name}-${link}`,
        title,
        link,
        description: cleanDescription ? `${cleanDescription}...` : '',
        pubDate: pubDate ? new Date(pubDate) : new Date(),
        author,
        image,
        source: feedConfig.name,
        sourceIcon: feedConfig.icon,
        sourceColor: feedConfig.color,
      });
    });

    return items.slice(0, 10); // Limit to 10 items per feed
  } catch (error) {
    console.error(`Error fetching RSS feed from ${feedConfig.name}:`, error);
    return [];
  }
}

export async function fetchAllFeeds() {
  const allPromises = RSS_FEEDS.map((feed) => fetchRSSFeed(feed));
  const results = await Promise.all(allPromises);

  // Flatten and sort by date
  const allItems = results.flat().sort((a, b) => b.pubDate - a.pubDate);

  return allItems;
}

export async function fetchFeedBySource(sourceName) {
  const feed = RSS_FEEDS.find((f) => f.name === sourceName);
  if (!feed) return [];
  return fetchRSSFeed(feed);
}

export { RSS_FEEDS };

export default fetchAllFeeds;
